export default "__VITE_ASSET__BtfgFJ0n__"